import { Eyebrow, Reveal, WHATSAPP_URL } from "./shared";

const OFFICES = [
    {
        name: "Afrinexa Global Ltd",
        lines: ["No. 44 University Road", "Ilorin, Kwara State, Nigeria"],
        badge: "CAC RC 8710821",
        testid: "trust-office-nigeria",
    },
    {
        name: "Afrinexa Global LLC",
        lines: ["150 E B St Lbby", "Casper, WY 82601, USA"],
        badge: "United States",
        testid: "trust-office-usa",
    },
];

export const Trust = () => (
    <section id="trust" data-testid="trust-section" className="bg-sand py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal>
                <Eyebrow>Our Presence</Eyebrow>
                <h2 className="mt-5 max-w-2xl font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                    Registered in Nigeria and the United States
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-12 md:grid-cols-2 md:gap-16">
                {OFFICES.map((office, i) => (
                    <Reveal key={office.name} delay={i * 0.1}>
                        <div data-testid={office.testid} className="border-t border-ink/15 pt-8">
                            <h3 className="font-serif text-2xl font-medium tracking-tight text-ink">
                                {office.name}
                            </h3>
                            <address className="mt-4 text-sm not-italic leading-relaxed text-ink/65">
                                {office.lines.map((line) => (
                                    <span key={line} className="block">
                                        {line}
                                    </span>
                                ))}
                            </address>
                            <p className="mt-5 inline-block border border-ink/15 px-3 py-1.5 text-[11px] font-medium uppercase tracking-[0.22em] text-ink/55">
                                {office.badge}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.15} className="mt-14">
                <div className="flex flex-col gap-4 border-t border-ink/10 pt-8 text-sm text-ink/65 sm:flex-row sm:items-center sm:gap-8">
                    <a
                        href="mailto:contact@afrinexaglobal.org"
                        data-testid="trust-email-contact-link"
                        className="transition-colors hover:text-forest"
                    >
                        contact@afrinexaglobal.org
                    </a>
                    <span className="hidden h-1 w-1 rotate-45 bg-champagne/60 sm:block" aria-hidden="true" />
                    <a
                        href="mailto:info@afrinexaglobal.org"
                        data-testid="trust-email-info-link"
                        className="transition-colors hover:text-forest"
                    >
                        info@afrinexaglobal.org
                    </a>
                    <span className="hidden h-1 w-1 rotate-45 bg-champagne/60 sm:block" aria-hidden="true" />
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="trust-whatsapp-link"
                        className="transition-colors hover:text-forest"
                    >
                        WhatsApp +234 814 063 5506
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
